import css from '@styled-system/css';
import styled from 'styled-components';
import { compose, space, color, typography, layout, flexbox, grid, background, border, position, shadow } from 'styled-system';

var Box = styled.div(function (_a) {
    var hoverProps = _a._hover, transition = _a.transition, cursor = _a.cursor;
    return css({
        boxSizing: "border-box",
        minWidth: 0,
        transition: transition,
        cursor: cursor,
        ":hover": hoverProps,
    });
}, compose(space, color, typography, layout, flexbox, grid, background, border, position, shadow));
var composeBox = compose(space, color, typography, layout, flexbox, grid, background, border, position, shadow);

export { Box, composeBox };
//# sourceMappingURL=Box.js.map
